module.exports = __webpack_public_path__ + "img/spain-stomach-cancer-male.9d2275f8.png";